export default "__VITE_ASSET__B6XvzX1N__"